import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const useTotalCounts = () => {
  return useQuery({
    queryKey: ["total-counts"],
    queryFn: async () => {
      const [tenderCountResponse, quotationCountResponse] = await Promise.all([
        axiosInstance.get("tenders-by-supplier/count?type=1"),
        axiosInstance.get("tenders-by-supplier/count?type=2"),
      ]);

      const tenderCounts = tenderCountResponse.data;
      const quotationCounts = quotationCountResponse.data;

      return {
        active_count: tenderCounts.active_count + quotationCounts.active_count,
        awarded_count:
          tenderCounts.awarded_count + quotationCounts.awarded_count,
        pending_count:
          tenderCounts.pending_count + quotationCounts.pending_count,
      };
    },
  });
};

export const useTendersAndQuotations = () => {
  return useQuery({
    queryKey: ["tenders-and-quotations"],
    queryFn: async () => {
      const [tendersResponse, quotationsResponse] = await Promise.all([
        axiosInstance.get("tenders-by-supplier?type=1"),
        axiosInstance.get("tenders-by-supplier?type=2"),
      ]);

      const tenders = tendersResponse.data;
      const quotations = quotationsResponse.data;

      return [...tenders, ...quotations];
    },
  });
};
